export const popKeyword = {
	GET_DAY: 'GET_DAY',
	GET_AMOUNT:'GET_AMOUNT',
	SET_TIME_STATUS: 'SET_TIME_STATUS',
	REQUEST_POPKEYWORD:'REQUEST_ALL_POPKEYWORD',
	RECEIVE_POPKEYWORD:'RECEIVE_ALL_POPKEYWORD'
};



// WEBPACK FOOTER //
// ./src/constants/popKeyword.constants.js